import React from 'react';
import { ExperienceSection } from '../components/ExperienceSection';
import { PageHeader } from '../components/PageHeader';
interface ExperiencePageProps {
  layout?: 'tabs' | 'accordion';
}
export function Experience({
  layout = 'tabs'
}: ExperiencePageProps) {
  return <>
      <PageHeader eyebrow="Experience & Governance" title="A record of appointments where scale, scrutiny and consequence were the baseline." intro="Board and corporate governance, federal executive leadership, state agency command and 35+ years of military service." data-id="element-304" data-mp="5j2lar81fmf4" />
      <ExperienceSection layout={layout} data-id="element-305" data-mp="3no5vgqcv2ome" />
    </>;
}